import { useState, useEffect } from "react";

const HeroSlider = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <>
      {images.map((image, index) => (
          <img
          key={index}
          src={image}
          alt={`Hero ${index + 1}`}
          className={`hero-image ${index === currentImageIndex ? 'active' : ''}`}
          />
        ))}
        </>
  );
};

export default HeroSlider;